import {
    damageReportStep,
    DamageDateAndLocationFormStepComponent,
    DamageDescriptionFormStepComponent,
    DamageReportForm,
    FileAttachmentFormStepComponent,
    DamageReportSummaryStepComponent,
    DamageReportStepConfig,
    DamageReportStep,
} from 'app/customer-portal/damage-reports';

export const auslandsKvDamageReportSteps: DamageReportStepConfig<DamageReportStep>[] = [
    damageReportStep('ort-und-datum', DamageDateAndLocationFormStepComponent),
    damageReportStep(
        'beschreibung',
        DamageDescriptionFormStepComponent,
        undefined,
        (form: DamageReportForm) =>
            form.controls.report.controls.damageDate.valid && form.controls.report.controls.location.valid,
    ),
    damageReportStep(
        'dateien-hochladen',
        FileAttachmentFormStepComponent,
        {
            introduction:
                'Bitte lade das folgende Dokument herunter, fülle es vollständig aus und füge es diesem Schadensbericht bei, bevor du ihn abschließt:',
            addition: `<p>
                <a href="/assets/documents/Schadenmeldung_Reise-Auslandskrankenversicherung.pdf" target="_blank" title="Schadenmeldung_Reise-Auslandskrankenversicherung.pdf (PDF, 192 KB)">
                    Schadenmeldung_Reise-Auslandskrankenversicherung.pdf<br />(PDF, 192 KB)
                </a>
            </p>
            <p>Damit hilfst Du uns, deinen Schadensfall möglichst schnell zu bearbeiten.</p>
            <p>Bitte füge außerdem die folgenden Dokumente bei:</p>
            <ul>
                <li>Rechnungen</li>
                <li>Im EU-Ausland <strong>Bescheid Ihrer gesetzlichen Krankenversicherung</strong></li>
                <li>
                    <strong>Quittungen und Zahlungsnachweis (Kontoauszug der Abbuchung bzw. Kreditkartenabrechnung)</strong>
                </li>
                <li>
                    Reisenachweise
                    <strong
                        >ab Deutschland / Wohnort (Bordkarten bei Flugreisen, / Zugticket bei Zugreisen / Tankquittungen,
                        Mautnachweise z.B. bei Autoreisen etc.)</strong
                    >
                </li>
                <li>Medizinische Berichte <strong>bitte mit Anamnese / Befund / Procedere / Diagnose</strong></li>
            </ul>`,
        },
        (form: DamageReportForm) => form.controls.report.valid,
    ),
    damageReportStep(
        'zusammenfassung',
        DamageReportSummaryStepComponent,
        undefined,
        (form: DamageReportForm) => form.controls.report.valid,
    ),
];
